import axios from "axios";
import React from "react";
import { toast } from "react-toastify";
import TableHeader from "../../Utility/TableHeader";
import { EyeIcon } from "lucide-react";
import { Tooltip } from "react-tooltip";
import DeleteConfirmation from "../../Utility/DeleteConfirmation";
import { Pagination } from "../../../helper/HelperTwo";

function LeadBranchList({
  setEditIdCryptForBranch,
  setOpenDialogBoxForBranch,
  setIsEditing,
  setSaveBtn,
  setBranchInputs,
  paginationBranchDatas,
  setLoading,
  fetchBranchesData,
  setCurrentPage,
  branchPermission,
}) {

  const headers = [
    "S No",
    "Logo",
    "Branch Name",
    "Branch Email",
    "Branch Phone",
    "Action",
  ];

  const handleViewForBranch = async (id_crypt) => {

    setLoading(true);
    setIsEditing(true);
    setOpenDialogBoxForBranch(true);
    setEditIdCryptForBranch(id_crypt);
    setSaveBtn("update");
    try {
      const response = await axios.get(
        `public/api/admin/branch/edit/${id_crypt}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );


      if (response.data.branch) {
        await fetchBranchesData();
        setBranchInputs((prev) => ({
          ...prev,
          branch_name: response.data.branch?.branch_name,
          branch_address_1: response.data.branch?.branch_address_1,
          branch_address_2: response.data.branch?.branch_address_2,
          branch_city: response.data.branch?.branch_city,
          branch_pincode: response.data.branch?.branch_pincode,
          branch_state: response.data.branch?.branch_state,
          branch_phone: response.data.branch?.branch_phone,
          branch_email: response.data.branch?.branch_email,
          branch_website: response.data.branch?.branch_website,
          branch_status: response.data.branch?.branch_status,
          branch_logo: response.data.branch?.branch_logo,
        }));
      }
    } catch (err) {
      toast.error(err.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page) => {
    if (page !== "..." && !isNaN(page)) {
      const newPage = Number(page);

      setCurrentPage(newPage);
      fetchBranchesData(newPage);
    }
  };

  return (
    <>
      <div className="grid md:grid-cols-1 gap-4">
        <div className="overflow-x-auto">
          <table className="min-w-full max-w-full divide-y divide-gray-300 mt-8">
            <TableHeader headers={headers} />
            <tbody className="divide-y divide-gray-200 bg-white">
              {paginationBranchDatas?.data?.map((branch, index) => (
                <tr
                  key={index}
                  className="hover:bg-gray-50 transition duration-300 ease-in-out"
                >
                  <td className="py-4 px-4 text-center text-md text-gray-500 whitespace-nowrap">
                    {index + 1}
                  </td>
                  <td className="py-4 px-4 text-center text-md text-gray-500 whitespace-nowrap flex justify-center">
                    <img
                      src={`http://localhost/kumaresh/leads%20management/lleads/storage/images/${branch.branchLogo}`}
                      alt="Branch Logo"
                      className="h-12 w-12 rounded-full object-cover "
                    />
                  </td>

                  <td className="py-4 px-4 text-center text-md text-gray-500 whitespace-nowrap">
                    {branch.branch_name}
                  </td>
                  <td className="py-4 px-4 text-center text-md text-gray-500 whitespace-nowrap">
                    {branch.branch_email}
                  </td>
                  <td className="py-4 px-4 text-center text-md text-gray-500 whitespace-nowrap">
                    {branch.branch_phone}
                  </td>

                  <td className="flex space-x-2 items-center justify-center py-4 px-4 text-center text-sm text-gray-500 whitespace-nowrap">
                    {branchPermission && (
                      <span
                        className="my-anchor-view relative group cursor-pointer bg-blue-400 rounded-md p-1"
                        onClick={() => handleViewForBranch(branch.id_crypt)}
                      >
                        <EyeIcon className="h-5 w-5 text-white" />
                        <Tooltip
                          anchorSelect=".my-anchor-view"
                          place="top"
                          className="text-xs p-0"
                          style={{ fontSize: "12px", padding: "0.3rem" }}
                        >
                          View
                        </Tooltip>
                      </span>
                    )}

                    {branchPermission && (
                      <DeleteConfirmation
                        id_crypt={branch.id_crypt}
                        apiType="branch"
                        fetchClientData={fetchBranchesData}
                        setLoading={setLoading}
                      />
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {paginationBranchDatas && (
          <Pagination
            links={paginationBranchDatas.links}
            currentPage={paginationBranchDatas.current_page}
            totalResults={paginationBranchDatas.total}
            from={paginationBranchDatas.from}
            to={paginationBranchDatas.to}
            lastPage={paginationBranchDatas.last_page}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
}

export default LeadBranchList;
